<sim-basic-material-dialog
	(closeClicked)="closeDialog()"
	[headerIcon]="{fontIcon: 'fa-images-user', fontSet: 'fad'}"
	[headerText]="T.SCENARIO_CREATE_MULTI_ROOM_RECORDING_SESSION | translate"
	[matDialogData]="data"
	[overflowHandledByChild]="true"
	[rect]="rect"
>
	<ng-container dialogContent>
		<sim-component-loading-container [isLoading]="store.isLoading()" [showBackDrop]="true" loadingIcon="fad fa-cube" />

		<div [style.visibility]="store.isLoading() ? 'hidden' : 'visible'" class="gridLayout">
			<sim-labelled-container class="paddingOverride" icon="fa-cube" label="CREATE_SESSION_DIALOG_CREATE_SESSION">
				<!--TITLE-->
				<mat-form-field color="accent">
					<mat-label>
						<mat-icon fontIcon="fa-signature" fontSet="fad" />
						{{ T.CREATE_SESSION_DAILOG_SESSION_NAME | translate }}
					</mat-label>
					<input [formControl]="store.metadataForm.controls.title" matInput />
				</mat-form-field>

				<!--DATE-->
				<mat-form-field color="accent">
					<mat-label>
						<mat-icon fontIcon="fa-calendar-day" fontSet="fad" />
						{{ T.LABEL_DATE | translate }}
					</mat-label>
					<input
						(click)="datepicker.open()"
						[formControl]="store.metadataForm.controls.date"
						[matDatepicker]="datepicker"
						[max]="eventEndDate()"
						[min]="eventStartDate()"
						matInput
						readonly
					/>
					<mat-error>
						{{ T.ERROR_INVALID | translate: {item: T.LABEL_DATE | translate} }}
					</mat-error>
					<mat-datepicker-toggle [for]="datepicker" matIconSuffix>
						<mat-icon color="accent" fontIcon="fa-calendar-day" fontSet="fad" matDatepickerToggleIcon />
					</mat-datepicker-toggle>
					<mat-datepicker #datepicker />
				</mat-form-field>

				<!--TIME-->
				<sim-clock-time-input
					[formCtrl]="store.metadataForm.controls.startTime"
					[labelKey]="T.SHARED_EVENT_SESSION_ESTIMATED_TIME_START"
				/>

				<!--PARTICIPANTS-->
				<!--TODO: hidden for now-->
				<!--<sim-autocomplete-->
				<!--	(onSelect)="addParticipant($any($event))"-->
				<!--	[dataType]="FetchDataType.SimUser"-->
				<!--	[labelToken]="T.LABEL_PARTICIPANTS"-->
				<!--	[excludeIds]="store.excludeUserIds()"-->
				<!--/>-->
				<!--<div class="scrollViewport">-->
				<!--	@for (participant of viewParticipants(); track participant.id) {-->
				<!--		<sim-user-list-item [user]="participant" [deletable]="true" (onDelete)="removeParticipant($event.id)" />-->
				<!--	}-->
				<!--</div>-->
			</sim-labelled-container>

			<sim-list [floatingLabel]="true" icon="fa-door-open" label="CREATE_SESSION_DIALOG_LIST_OF_STATIONS">
				<ng-container actions>
					<sim-new-list-item
						(add)="store.stationAdded()"
						[disabled]="store.metadataForm.invalid || store.stationForms.invalid"
						buttonLabel="BUTTON_CREATE"
						primaryLabel="CREATE_SESSION_DIALOG_NEW_STATION"
					/>
				</ng-container>
				@for (station of store.viewStations(); track station.id) {
					@let stationForm = store.stationForms.at($index);
					@let preventSelection = store.stationIndex() ? store.stationIndex() !== $index && store.stationForms.invalid : false;
					<sim-list-item
						#listItem
						(onClick)="store.stationSelected($index)"
						[indicator]="$index + 1"
						[invalid]="stationForm.invalid"
						[preventSelection]="preventSelection"
						[primaryLabel]="station.room?.name ?? (T.CREATE_SESSION_DIALOG_STATION_LIST_ITEM_EMPTY | translate)"
						[secondaryLabel]="station.scenario?.name ?? null"
						[selected]="store.stationIndex() === $index"
						[tooltip]="listItem.preventSelection() ? (T.ERROR_STATION_FORM_INVALID | translate) : null"
					>
						<ng-container actions>
							<button
								(click)="store.stationDeleted($index)"
								[disabled]="preventSelection"
								appStopPropagation
								color="warn"
								mat-icon-button
							>
								<mat-icon fontIcon="fa-trash-alt" fontSet="fad" />
							</button>
						</ng-container>
					</sim-list-item>
				}
			</sim-list>
			<sim-labelled-container icon="fa-cube" label="CREATE_SESSION_DIALOG_STATION_CONFIG">
				@let currentStationForm = store.currentStationForm();
				@if (currentStationForm) {
					@if (!store.isFormCooldown()) {
						<!--TRAINING ROOM-->
						<sim-chip-autocomplete
							#roomField
							(onLoad)="onFormLoad(roomField)"
							[dataType]="FetchDataType.TrainingRoom"
							[excludeIds]="store.excludeRoomIds()"
							[formCtrl]="currentStationForm!.controls.room"
							[hidden]="!areFormsLoaded()"
							[labelToken]="T.CREATE_SESSION_DIALOG_TRAINING_ROOM_LABEL"
							subscriptSizing="fixed"
						>
							<ng-container labelPrefix>
								<mat-icon fontIcon="fa-door-open" fontSet="fad" />
							</ng-container>

							<ng-container actions>
								<button (click)="openRoomDetailDialog()" color="accent" mat-icon-button>
									<mat-icon fontIcon="fa-th" fontSet="fad" />
								</button>
							</ng-container>
						</sim-chip-autocomplete>

						<!--SCENARIO-->
						<sim-chip-autocomplete
							#scenarioField
							(onLoad)="onFormLoad(scenarioField)"
							[dataType]="FetchDataType.Scenario"
							[formCtrl]="currentStationForm.controls.scenario"
							[hidden]="!areFormsLoaded()"
							[labelToken]="T.CREATE_SESSION_DIALOG_ADD_SCENARIO"
						>
							<mat-icon fontIcon="fa-ballot-check" fontSet="fad" labelPrefix />
						</sim-chip-autocomplete>

						@if (!areFormsLoaded()) {
							<div class="emptyState secondary">
								<mat-spinner color="accent" />
							</div>
						}
					}
				} @else {
					<div class="emptyState secondary">
						<mat-icon fontIcon="fa-empty-set" fontSet="far" />
						<label>{{ T.GENERAL_TXT_LIST_EMPTY | translate }}</label>
					</div>
				}
			</sim-labelled-container>
		</div>
	</ng-container>

	<ng-container actions>
		<!--AUTOSAVE-->
		<sim-autosave-widget
			[promise]="store.autosaveConfig().promise"
			[timestamp]="store.session()?.lastUpdateTime"
			[warningMessage]="null"
		/>

		<sim-button
			(onClick)="closeDialog()"
			[appBusy]="store.autosaveConfig().promise ?? closePromise()"
			[disabled]="store.metadataForm.invalid || store.stationForms.invalid"
			[icon]="{fontSet: 'fad', fontIcon: 'fa-check'}"
			[label]="T.BUTTON_FINISH"
			color="accent"
		/>
	</ng-container>
</sim-basic-material-dialog>
